import type { DetailsWheels } from '@autobid/ui/types/components/CarDetails'

export function useDetailsWheels(wheels: DetailsWheels | undefined) {
  const tableWithWheelTitles = computed(() =>
    wheels?.tables.map((table, tableIndex) => {
      if (tableIndex === 0)
        return table

      const TH_OF_WHEEL_TITLE = ''

      return {
        ...table,
        table: {
          ...table.table,
          tableHeadings: [TH_OF_WHEEL_TITLE, ...table.table.tableHeadings || []],
          tableCells: table.table.tableCells.map((row, rowIndex) => {
            const rowTitle = wheels.tables[0].table.tableCells[rowIndex][0]

            return [rowTitle, ...row]
          }),
        },
      }
    }),
  )

  return { tableWithWheelTitles }
}
